import React, { useEffect, useState } from "react";
import "../Categories/CategoriesGroupsList.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { IoMdArrowBack } from "react-icons/io";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  avatar,
  CategoriesGroupscard1,
  fill_heart,
  heart_icon,
  lock_icon,
  nano_technology,
  subscription_icon,
} from "../../../assets";
import { CiSearch } from "react-icons/ci";
import { BsDot } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { groupListingApi } from "../../../services/groups";
import useShimmer from "../../../hooks/useShimmer";
import useDebounce from "../../../hooks/useDebounce";
import { decryptData } from "../../../utils/dataCipher";
import InfiniteScroll from "react-infinite-scroll-component";
import { GroupCardSkeleton } from "../../../shimmer/groups/GroupsListingShimmer";
import { updateFavoriteListHandler } from "../Groups/groupSubModules/LikeUnlikeHeart";
import { getCategoryListApi, getOverviewCategoryListApi } from "../../../services/categories";
import { toastMessage } from "../../../utils/toastMessage";

const CategoriesGroupsList = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [groupList, setGroupList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const debouncedValue = useDebounce(search, 300);
  const navigate = useNavigate();
  const type = ''
  let categoryData = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(categoryData).length) {
    encryptedData = decryptData(categoryData);
  }
  // console.log('encryptedData', encryptedData)
  //---------------listing-API--------------------
  const fetchingGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await getCategoryListApi({
        pagination: "true",
        search: debouncedValue,
        limit: 10,
        page: page,
        categoryName: encryptedData?.name,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 10);
      } else {
        toastMessage(message, 'error', 'groupListDetails')
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  //---------------listing-API--------------------
  const fetchingOverviewGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await getOverviewCategoryListApi({
        pagination: "true",
        search: debouncedValue,
        limit: 10,
        page: page,
        categoryName: encryptedData?.name,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 10);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    if (encryptedData?.type === 'overview') {
      fetchingOverviewGroupListHandler(1, true);
    } else {
      fetchingGroupListHandler(1, true);
    }
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      if (encryptedData?.type === 'overview') {
        fetchingOverviewGroupListHandler(nextPage);
      } else {
        fetchingGroupListHandler(nextPage);
      }
      return nextPage;
    });
  };
  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/category/groups/${id}`)
  }
  return (
    <>
      <DashboardHeader title={"Overview"} />

      <div className="CategoriesGroupsList_parent">
        <div className="CategoriesGroupsList_header">
          <div className="CategoriesGroupsList_backbtn">
            <Link to={-1}>
              <IoMdArrowBack className="backarrow" />
            </Link>
          </div>

          <div className="technologies_list">
            <img src={encryptedData?.image || avatar} />
            <span className="tech_list_name">{encryptedData?.name}</span>
          </div>

          <div className="msg_list_search-bar">
            <input
              type="text"
              className="msg-search-input"
              placeholder="Search here"
              size="30"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <CiSearch className="search_icon" />
          </div>
        </div>

        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          <InfiniteScroll
            dataLength={groupList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<GroupCardSkeleton count={5} />}
            endMessage={
              <p style={{ textAlign: "center", margin: "25px" }}>
                <b>No more data to display</b>
              </p>
            }
            scrollableTarget="scrollableContainer"
          >
            <div className="health_hub_cards">
              {groupList && groupList.length > 0 ? groupList?.map((data, ind) => (
                <div key={data?._id} className="health_hub_img">

                  <div onClick={() => navigateDetailsPage(data?._id)} className="image_containerss pointer-cursor">
                    <img src={data?.coverImage} />
                    <div className="health_hub_img_text">
                      <h6>{data?.name}</h6>
                      <p>
                        {data?.newFeeds?.count > 0 ? (
                          <>
                            <GoDotFill className="live_dot" />
                            {`${data?.newFeeds?.count} New Post${data?.newFeeds?.count > 1 ? 's' : ''}`}
                          </>
                        ) : null}
                      </p>
                    </div>
                  </div>

                  <div className="health_hub_containt">
                    <div className="rgt_tan_wrap">
                      <span>{data?.categoryName}</span>
                    </div>

                    <figure className="health_hub_icons">
                      {data?.type === "SUBSCRIPTION" && (
                        <img src={subscription_icon} className="lockimg" />
                      )}
                      {data?.type === "PRIVATE" && (
                        <img src={lock_icon} className="lockimg" />
                      )}
                      <img
                        src={data?.favoriteGroup?.status === "ACTIVE" ? fill_heart : heart_icon}
                        className="heartimg"
                        onClick={() =>
                          updateFavoriteListHandler(
                            data?._id,
                            setGroupList,
                            data?.favoriteGroup?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
                          )
                        }
                      />
                    </figure>
                  </div>
                </div>
              )) : null}
            </div>
          </InfiniteScroll >
        </div >
      </div>
    </>
  );
};

export default CategoriesGroupsList;
